<template>
	<LazyHydrate when-visible>
		<layoutSection class="rounded-GO tablet:rounded-tr-none">
			<div class="px-16 tablet:px-48 desktop:px-56 desktopWide:px-0">
				<div class="space-y-10 tablet:space-y-48 desktop:space-y-56">
					<div class="space-y-32 tabletWide:w-9/12 desktop:w-8/12">
						<h2 class="font-bold text-32 tablet:text-40 desktop:text-48">Total Road Care</h2>
						<p class="text-18 desktop:text-22">A comprehensive $3 per day fee ensures your journey is simple and stress-free, we include the following services:</p>
					</div>
					<ul class="tablet:text-14 desktop:text-16 grid grid-cols-1 tablet:grid-cols-2 tabletWide:grid-cols-3 gap-16 tabletWide:gap-y-32 desktop:w-10/12">
						<li v-for="item in list" :key="item.icon" class="flex flex-col space-y-16 p-24 bg-goPinkBrighter rounded-6 border border-goPink/5 shadow-sm">
							<svg-icon :name="item.icon" class="iconSize-32 text-goPink" />
							<p class="font-bold text-goPink text-20">{{ item.title }}</p>
							<p>{{ item.text }}</p>
						</li>
					</ul>
					<div class="space-y-32 tabletWide:w-9/12 desktop:w-8/12">
						<p>With Total Road Care, we handle all the essentials so you can focus on the adventure ahead.</p>
						<div class="tablet:text-14 leading-24">
							<nuxt-link to="/terms/" class="button button-normal button-goPinkGhost">Terms and Conditions</nuxt-link>
						</div>
					</div>
				</div>
			</div>
		</layoutSection>
	</LazyHydrate>
</template>

<script>
import layoutSection from '~/components/layoutSection.vue'

export default {
	components: {
		layoutSection
	},
	data() {
		return {
			list: [
				{
					icon: 'road-assistance',
					title: 'Roadside Assistance',
					text: 'Complimentary callout service for ALL types of breakdowns.'
				},
				{
					icon: 'insurance-excess-outline',
					title: 'Government Road Taxes',
					text: 'Covers registration costs, safety inspections and road user charges.'
				},
				{
					icon: 'no-hidden-cost',
					title: 'Toll Road Freedom',
					text: 'Enjoy free passage on all toll roads, we cover all costs including admin fees.'
				},
			],
		}
	}
}
</script>
